import React from 'react';
import _ from 'lodash';
import { FormikProps } from 'formik';
import { FormField } from '../../../global/components/form-element/form-field';
import { ClergyBioSettings } from '../../arc/models/arc-epi-props';
import { CleryBioProfessionalItem } from '../model/clergy-bio-app-models';
import { deleteAction } from './models/form-models';
import { buttonStyles } from '../../../global/constants/theme/styles/components/buttonstyles';
import { ContentSpacer } from '../../../global/components/layout/generic-content-spacer';
import { FormGroup } from '../../../global/components/layout/form-group';



interface Props {
	settings: ClergyBioSettings;
	id: string;
	arrayField: string;
	formikProps: FormikProps<any>;
	professionalItem: CleryBioProfessionalItem;
	defaultValue: CleryBioProfessionalItem;
	setList?: any;
}

function ClergyBioSocietyItem(props: Props) {
	const buttonClasses = buttonStyles();

	const { settings, arrayField, id, formikProps, setList, professionalItem, defaultValue } = props;


	const remove = () => {
		const list = _.cloneDeep(formikProps?.values[arrayField]);
		const toDelete = { ...defaultValue };
		toDelete.action = deleteAction;
		list[id] = toDelete;
		const copy = { ...formikProps?.values };
		copy[arrayField] = list;
		setList(copy);
	};

	if (professionalItem?.action === deleteAction) {
		return null;
	}

	return (
		<ContentSpacer>
			<FormGroup>
				<FormField
					name={`${arrayField}.${id}.name`}
					label={settings?.nameOfSocietyLabel}
					component='input'
					touched={formikProps.touched}
					errors={formikProps.errors}
					required
				/>

				<FormField
					name={`${arrayField}.${id}.startYear`}
					label={settings?.yearBeginLabel}
					component='input'
					touched={formikProps.touched}
					errors={formikProps.errors}
					required
				/>

				<FormField
					name={`${arrayField}.${id}.endYear`}
					label={settings?.yearEndLabel}
					component='input'
					touched={formikProps.touched}
					errors={formikProps.errors}

				/>

				<div className='form-item'><button className={buttonClasses.linkButton} type='button' onClick={() => remove()} >{settings?.removeChildButtonText}</button></div>

			</FormGroup>
		</ContentSpacer>
	);
}

ClergyBioSocietyItem.defaultProps = {
	setList: null,
};
export default ClergyBioSocietyItem;